<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Instalação do NodeJs</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            <p>
              Instalar o NodeJs é muito simples. Basta navegarmos até
              <a
                target="_blank"
                href="https://nodejs.org/en/"
              >seu site</a> e fazer o download de seu instalador.
            </p>
          </v-col>

          <v-col class="col-6 offset-3">
            <v-img src="@/assets/NodeJs.jpg"></v-img>
          </v-col>

          <v-col class="mt-3 col-10 offset-1">
            <p>
              Basta clicar no botão verde para fazer o download do instalador. Aconselho a baixar a versão LTS, que possui um
              grau de estabilidade maior.
            </p>
            <p>Após o download, executar o instalador. Muito simples, por sinal.</p>
            <p>
              Note-se que eu falei sobre instalar versões de 32 bits para que a nossa futura aplicação seja compatível com máquinas de usuários
              tanto de 32 quanto de 64 bits. No entanto, no caso específico do NodeJs tanto faz a versão instalada, pois isso não afetará o
              resultado final desejado.
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/installc">Instalação do C/C++</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Installnode",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
